define('uikit/uikit',['require','exports','module','marionette','underscore','json!./version.json','./mixins/component.mixin','./mixins/injector.mixin','./elements/button','./elements/checkbox','./elements/dropdown','./elements/header','./elements/input','./elements/label','./elements/progress','./elements/text','./elements/divider','./elements/help.text.icon','./elements/component.with.help.text','./elements/header.with.help.text.view','./collections/breadcrumb','./collections/checkbox.group','./collections/container','./collections/form','./collections/grid','./collections/list','./collections/search.results','./collections/segment.list','./collections/steps','./collections/table','./collections/tabs','./collections/tree','./collections/reordarable.collection.view','./modules/accordion','./modules/calendar','./modules/dimmer','./modules/expandable.menu','./modules/input.currency','./modules/input.counter','./modules/input.date','./modules/input.time','./modules/instant.notifications','./modules/loader','./modules/menu','./modules/message','./modules/modal','./modules/pagination','./modules/popup','./modules/sidebar','./modules/tag.input','./modules/token.input','./modules/tutorial','./modules/visualsearch','./views/form.wrapper','./views/table.add','./views/table.ellipsis','./views/table.navigation','./views/table.remove','./views/table.selected','./extra/size','./extra/static.methods','./helper/freeze','./config','./collections/components.container.view','./modules/dimmer2','./modules/modal2','./modules/sidebar2','./modules/sidebar.menu','./behaviors/hide.when.collection.empty.behavior'],function(require, exports, module) {
  var Mn = require('marionette');
  var _ = require('underscore');
  var version = require('json!./version.json');
  var ComponentMixin = require('./mixins/component.mixin');
  var InjectorMixin = require('./mixins/injector.mixin');
  var Button = require('./elements/button');
  var Checkbox = require('./elements/checkbox');
  var Dropdown = require('./elements/dropdown');
  var Header = require('./elements/header');
  var Input = require('./elements/input');
  var Label = require('./elements/label');
  var Progress = require('./elements/progress');
  var Text = require('./elements/text');
  var Divider = require('./elements/divider');
  var HelpTextIcon = require('./elements/help.text.icon');
  var ComponentWithHelpText = require('./elements/component.with.help.text');
  var HeaderWithHelpText = require('./elements/header.with.help.text.view');
  var Breadcrumb = require('./collections/breadcrumb');
  var CheckboxGroup = require('./collections/checkbox.group');
  var Container = require('./collections/container');
  var Form = require('./collections/form');
  var Grid = require('./collections/grid');
  var List = require('./collections/list');
  var SearchResults = require('./collections/search.results');
  var SegmentList = require('./collections/segment.list');
  var Steps = require('./collections/steps');
  var Table = require('./collections/table');
  var Tabs = require('./collections/tabs');
  var Tree = require('./collections/tree');
  var ReordarableCollectionView = require('./collections/reordarable.collection.view');
  var Accordion = require('./modules/accordion');
  var Calendar = require('./modules/calendar');
  var Dimmer = require('./modules/dimmer');
  var ExpandableMenu = require('./modules/expandable.menu');
  var InputCurrency = require('./modules/input.currency');
  var InputCounter = require('./modules/input.counter');
  var InputDate = require('./modules/input.date');
  var InputTime = require('./modules/input.time');
  var InstantNotifications = require('./modules/instant.notifications');
  var Loader = require('./modules/loader');
  var Menu = require('./modules/menu');
  var Message = require('./modules/message');
  var Modal = require('./modules/modal');
  var Pagination = require('./modules/pagination');
  var Popup = require('./modules/popup');
  var Sidebar = require('./modules/sidebar');
  var TagInput = require('./modules/tag.input');
  var TokenInput = require('./modules/token.input');
  var Tutorial = require('./modules/tutorial');
  var VisualSearch = require('./modules/visualsearch');
  var EditableField = require('./views/form.wrapper');
  var TableAdd = require('./views/table.add');
  var TableEllipsis = require('./views/table.ellipsis');
  var TableNavigation = require('./views/table.navigation');
  var TableRemove = require('./views/table.remove');
  var TableSelected = require('./views/table.selected');
  var Size = require('./extra/size');
  var StaticMethods = require('./extra/static.methods');
  var Freeze = require('./helper/freeze');

  var UIKit = (this.UIKit = this.UIKit || {});

  UIKit.version = version.version;

  _.extend(UIKit, {
    config: require('./config'),

    ComponentMixin: ComponentMixin,
    InjectorMixin: InjectorMixin,

    Button: Button,
    Checkbox: Checkbox,
    Dropdown: Dropdown,
    Header: Header,
    Input: Input,
    Label: Label,
    Progress: Progress,
    Text: Text,
    Divider: Divider,
    HelpTextIcon: HelpTextIcon,
    ComponentWithHelpText: ComponentWithHelpText,
    HeaderWithHelpText: HeaderWithHelpText,

    Breadcrumb: Breadcrumb,
    CheckboxGroup: CheckboxGroup,
    Container: Container,
    ComponentsContainerView: require('./collections/components.container.view'),
    Form: Form,
    Grid: Grid,
    List: List,
    SearchResults: SearchResults,
    SegmentList: SegmentList,
    Steps: Steps,
    Table: Table,
    Tabs: Tabs,
    Tree: Tree,

    Accordion: Accordion,
    Calendar: Calendar,
    Dimmer: Dimmer,
    Dimmer2: require('./modules/dimmer2'),
    ExpandableMenu: ExpandableMenu,
    InputCurrency: InputCurrency,
    InputCounter: InputCounter,
    InputDate: InputDate,
    InputTime: InputTime,
    InstantNotifications: InstantNotifications,
    Loader: Loader,
    Menu: Menu,
    Message: Message,
    Modal: Modal,
    Modal2: require('./modules/modal2'),
    Pagination: Pagination,
    Popup: Popup,
    Sidebar: Sidebar,
    Sidebar2: require('./modules/sidebar2'),
    SidebarMenu: require('./modules/sidebar.menu'),
    TagInput: TagInput,
    TokenInput: TokenInput,
    Tutorial: Tutorial,
    VisualSearch: VisualSearch,

    EditableField: EditableField,
    TableAdd: TableAdd,
    TableEllipsis: TableEllipsis,
    TableNavigation: TableNavigation,
    TableRemove: TableRemove,
    TableSelected: TableSelected,

    Size: Size,

    ItemView: Mn.ItemView.extend(ComponentMixin, StaticMethods),
    CollectionView: Mn.CollectionView.extend(ComponentMixin, StaticMethods),
    ReordarableCollectionView: ReordarableCollectionView.extend(ComponentMixin, StaticMethods),
    // this should not be here...keeping it for any external code that depends on it
    ComponentView: Mn.CompositeView.extend(ComponentMixin),
    CompositeView: Mn.CompositeView.extend(ComponentMixin),
  });

  // behaviors

  _.extend(UIKit, {
    HideWhenCollectionEmptyBehavior: require('./behaviors/hide.when.collection.empty.behavior'),
  });

  // static functions
  _.extend(UIKit, {
    freezeOption: Freeze.freezeOption,
    unfreezeOption: Freeze.unfreezeOption,
  });

  module.exports = UIKit;
});

